
class LabelHelper {
    /**
     * Renders a numeric range between two integers as a string representation.
     * @param {*} min The starting integer of the range.
     * @param {*} max The ending integer of the range.
     * * @param {boolean} [allowZeroMinValue=true] specifies if we should allow 0 to be displayed if that is the min value
     * @returns A string representing the numeric range between 'a' and 'b'.
     */
    static renderNumericRange(min, max, allowZeroMinValue = true)
    {
        // From this ticket: https://jfshea.atlassian.net/browse/STWRDP3-7608,
        // remove support for min half bath value of 0, so alter the value of the min accordingly
        min = (!allowZeroMinValue && min == 0 && min < max) ? (min + 1) : min;

        // Set max to min to previent diplaying 0-N
        if (max < min) { max = min; }

        // Check if 'a' and 'b' are equal
        if (min == max)
        {
            // If equal, return a string with the single value 'a'
            return `${min}`;
        }
        else if (min < max)
        {
            // If 'a' is less than 'b', return a string representing the range from 'a' to 'b'
            return `${min}-${max}`;
        }
        else
        {
            // If 'a' is greater than 'b', return a string representing the range from 'b' to 'a'
            return `${max}-${min}`;
        }
    }

    /**
     * Renders a numeric label based on the values of 'a' and 'b', returning either a singular or plural term.
     * @param {number} min The first numeric value for comparison
     * @param {number} max The second numeric value for comparison
     * @param {string} singularTerm The term to return if both 'a' and 'b' are equal to 1.
     * @param {string} pluralTerm The term to return if 'a' and 'b' are not both 1
     * @param {boolean} [allowZeroMinValue=true] specifies if we should allow 0 to be displayed if that is the min value
     * @returns A string representing the appropriate term based on the numeric comparison.
     */
    static renderNumericLabel(min, max, singularTerm, pluralTerm, allowZeroMinValue = true)
    {
        // From this ticket: https://jfshea.atlassian.net/browse/STWRDP3-7608,
        // remove support for min half bath value of 0, so alter the value of the min accordingly
        min = (!allowZeroMinValue && min == 0 && min < max) ? (min + 1) : min;

        // Check if 'a' and 'b' are equal to 1 or max is 0
        if (min == 1 && max <= 1)
        {
            // If both 'a' and 'b' are equal to 1
            // or max = 0, return the singular term
            return singularTerm;
        }
        else
        {
            // If 'a' and 'b' are not both 1 or are different, return the plural term
            return pluralTerm;
        }
    }
}

export default LabelHelper;